__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "odh-dashboard-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@odh-dashboard/connection-types", "0.0.0", () => (Promise.all([__webpack_require__.e(9390), __webpack_require__.e(6238), __webpack_require__.e(1338)]).then(() => (() => (__webpack_require__(91338))))));
			register("@odh-dashboard/foundation", "0.0.0", () => (__webpack_require__.e(4951).then(() => (() => (__webpack_require__(34951))))));
			register("@odh-dashboard/k8s-core", "0.0.0", () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(1004), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(40283))))));
			register("@odh-dashboard/plugin-core", "0.0.0", () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(8212), __webpack_require__.e(6288), __webpack_require__.e(1645), __webpack_require__.e(5969)]).then(() => (() => (__webpack_require__(85969))))));
			register("@odh-dashboard/ui-core", "0.0.0", () => (Promise.all([__webpack_require__.e(6384), __webpack_require__.e(8414), __webpack_require__.e(8212), __webpack_require__.e(3106), __webpack_require__.e(4241), __webpack_require__.e(9390), __webpack_require__.e(519), __webpack_require__.e(6097)]).then(() => (() => (__webpack_require__(86097))))));
			register("@openshift/dynamic-plugin-sdk-utils", "5.0.1", () => (() => (__webpack_require__(3791))), 1);
			register("@openshift/dynamic-plugin-sdk", "5.0.1", () => (() => (__webpack_require__(87835))), 1);
			register("@patternfly/react-code-editor", "6.4.1", () => (Promise.all([__webpack_require__.e(6733), __webpack_require__.e(3449), __webpack_require__.e(8414), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(76207))))));
			register("@patternfly/react-core", "6.4.1", () => (Promise.all([__webpack_require__.e(6733), __webpack_require__.e(5), __webpack_require__.e(8414), __webpack_require__.e(3106), __webpack_require__.e(262), __webpack_require__.e(7505), __webpack_require__.e(6727)]).then(() => (() => (__webpack_require__(6727))))));
			register("@patternfly/react-icons", "6.4.0", () => (() => (__webpack_require__(5405))), 1);
			register("@tanstack/react-query", "4.44.0", () => (__webpack_require__.e(5184).then(() => (() => (__webpack_require__(35184))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(78325))), 1);
			register("react-router-dom", "7.18.0", () => (() => (__webpack_require__(65464))), 1);
			register("react-router", "7.18.0", () => (() => (__webpack_require__(79227))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(63696))), 1);
			register("use-query-params", "2.2.2", () => (__webpack_require__.e(5975).then(() => (() => (__webpack_require__(85975))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};